if(!customElements.get("carousel-component")) {
class Carousel extends HTMLElement {
  constructor() {
    super();
    this.carouselElement = this;

    // Carousel element should have class splide
    if (!this.carouselElement.classList.contains('splide')) return;

    this.customSlider = this.classList.contains('custom-slider-container') ? true : false

    this.desktopPerPage = this.carouselElement.dataset['desktopperpage'] || 4;
    this.mobilePerPage = parseFloat(this.carouselElement.dataset['mobileperpage']) || 2.5;
  
    this.focus = this.customSlider ? 'left' : this.carouselElement.dataset['focus'] || 'center';
    this.type = this.carouselElement.dataset['type'] || 'loop';
    this.gap = this.carouselElement.dataset['gapbetweenslides']  || 20;
    this.autoplaySpeed = parseInt(this.dataset['autoplaySpeed']) || 3000;
    this.carouselOnDesktop = this.carouselElement.dataset['carouseondesktop'] === 'false' ? true : false;
   
    
    


    this.desktopPaddingValue = this.carouselElement.dataset['desktoppadding'];
    this.desktopPadding = this.customSlider ? { left: 0, right: this.desktopPaddingValue }: 0;
    this.mobileLeftPaddingValue = this.carouselElement.dataset['mobileleftpadding'];
    this.mobileRightPaddingValue = this.carouselElement.dataset['mobilerightpadding'];
    this.mobileRightPadding = this.carouselElement.dataset['mobileenablerightpadding'] === 'true' ? this.mobileRightPaddingValue : 0;
    this.mobileLeftPadding = this.carouselElement.dataset['mobileenableleftpadding'] === 'true' ?  this.mobileLeftPaddingValue : 0;
    this.Mobilepadding = { left: this.mobileLeftPadding, right: this.mobileRightPadding }

    // Data attribute string matching for correct boolean value
    // The fallback is used if the developer make mistake the code is forgiving
    // Read more here https://stackoverflow.com/questions/263965/how-can-i-convert-a-string-to-boolean-in-javascript
    this.showarrows = this.carouselElement.dataset['showarrows'] === 'true' || false;
    this.autoplay = this.carouselElement.dataset['autoplay'] === 'true' || false;
    this.showarrowsonmobile = this.carouselElement.dataset['showarrowsonmobile'] === 'true' || false;
    this.showdots = this.carouselElement.dataset['showdots'] === 'true' || false;
    this.isNavigation = this.carouselElement.dataset['isnavigation'] === 'true' || false;
    this.disableDrag = this.carouselElement.dataset['disabledrag'] === 'true' || false;

    this.sync = this.carouselElement.dataset['carouselsyncselector'] || false;
    this.mobileFoucs = this.carouselElement.dataset['mobile_focus'];

    this.initCarousel();
  }

  initCarousel() {
    // More option available here https://splidejs.com/documents/
    // This slider can be customized as require check the above doc before adding any new 
    // Slider library.
    this.carousel = new Splide(this.carouselElement, {
      perPage: this.desktopPerPage,
      type: this.type,
      focus: this.focus,
      autoplay: this.autoplay,
      interval: this.autoplaySpeed,
      gap: this.gap,
      arrows: this.showarrows,
      pagination: this.showdots,
      isNavigation: this.isNavigation,
      drag: !this.disableDrag,
      padding: this.desktopPadding,
      drag:true,
      destroy:this.carouselOnDesktop,
      breakpoints: {
        767: {
          perPage: this.mobilePerPage,
          arrows: this.showarrowsonmobile,
          pagination: this.showdots,
          padding: this.Mobilepadding,
          destroy:false,
          gap:'12px',
          drag:true,
        }
      },
    });

    if (this.sync) {
      this.initCarouselSync()
    } else {
      this.carousel.mount();
    }
  }

  initCarouselSync() {
    this.syncElement = document.querySelector(this.sync);

    this.carouselSync = new Splide(this.sync, {
      updateOnMove: true,
      perPage: this.syncElement.dataset['desktopperpage'] || 5,
      type: this.syncElement.dataset['type'] || 'loop',
      focus: this.syncElement.dataset['focus'] || 'center',
      isNavigation: this.syncElement.dataset['isnavigation'] === 'true' || false,
      pagination: false,
      arrows: this.syncElement.dataset['showarrows'] === 'true' || false,
    });

    this.carousel.sync(this.carouselSync);
    this.carousel.mount();
    this.carouselSync.mount();
  };

  refreshSlider() {
    this.carousel.refresh();
    if (this.carouselSync) {
      this.carouselSync.refresh();
    }
  }
}
window.Carousel = Carousel;
customElements.define('carousel-component', Carousel);

}